import { render, staticRenderFns } from "./modalProductoEliminado.vue?vue&type=template&id=8e162f26&scoped=true"
import script from "./modalProductoEliminado.vue?vue&type=script&lang=js"
export * from "./modalProductoEliminado.vue?vue&type=script&lang=js"
import style0 from "./modalProductoEliminado.vue?vue&type=style&index=0&id=8e162f26&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8e162f26",
  null
  
)

export default component.exports